export const VALUES = [
  {
    id: 1,
    name: 'Aim for the ideal',
    description:
      'Imagine the ideal and try to make it. Build things that improve the world.',
    frontBg: '#50AEEB',
    backBg: '#1A94E4'
  },
  {
    id: 2,
    name: 'Be authentic',
    description:
      'Be the same on the outside as you are on the inside. Say what you think is true instead of what other people want to hear.',
    frontBg: '#E1718B',
    backBg: '#CA2B50'
  },
  {
    id: 3,
    name: `Create, don't copy`,
    description:
      'Choose creativity over efficiency. To create is to lead, to copy is to follow. We are here to build something new.',
    frontBg: '#C76358',
    backBg: '#AF463A'
  },
  {
    id: 4,
    name: 'Simpler is better',
    description:
      'Make it remarkable for some instead of good for everyone. Remove the noise to highlight the value.',
    frontBg: '#EDAD68',
    backBg: '#E78F31'
  },
  {
    id: 5,
    name: 'Do only what matters',
    description: `Prioritize your actions and focus on what's important. The most impactful actions make the difference.`,
    frontBg: '#EDCE68',
    backBg: '#DEB11A'
  },
  {
    id: 6,
    name: 'Make things people love',
    description:
      'Listen to the user and do things really well. Great things made with care are remembered forever.',
    frontBg: '#50AEEB',
    backBg: '#1A94E4'
  },
  {
    id: 7,
    name: 'Dare to make mistakes',
    description: `Improvements are always possible. If you aren't prepared to be wrong, you won't do anything creative.`,
    frontBg: '#E1718B',
    backBg: '#CA2B50'
  },
  {
    id: 8,
    name: 'Let the best idea win',
    description:
      'The right thing to do is our highest authority. Take suggestions, not orders.',
    frontBg: '#C76358',
    backBg: '#AF463A'
  },
  {
    id: 9,
    name: 'You can do it',
    description: 'The only thing standing between you and a goal is knowing how to.',
    frontBg: '#EDAD68',
    backBg: '#E78F31'
  },
  {
    id: 10,
    name: 'Be good to each other',
    description:
      'Be charitable in interpretation. Speak your mind and take people seriously. What you do becomes the culture.',
    frontBg: '#EDCE68',
    backBg: '#E7BC31'
  }
];
